<template>
  <div class="employee">
    <CCard class="card-table-emloyee">
      <CRow>
        <CCol sm="2">
          <div class="form-group">
            <label>{{
              $t(
                "placeholder.label_employee_over_time_request_search_code_name"
              )
            }}</label>
            <CInput
              v-model="searchData.info"
              :placeholder="
                this.$t(
                  'placeholder.label_employee_over_time_request_search_code_name'
                )
              "
              v-on:keyup.enter="search"
            />
          </div>
        </CCol>
        <CCol sm="2">
          <div class="form-group">
            <label>{{ $t("employee.label_employee_position") }}</label>
            <select
              class="form-control"
              v-model="searchData.positionId"
              @change="search"
            >
              <option value="0">{{
                $t("placeholder.label_employee_option_search")
              }}</option>
              <option
                :value="item.id"
                v-for="(item, index) in positions"
                :key="index"
                >{{ item.name }}</option
              >
            </select>
          </div>
        </CCol>
        <CCol sm="2">
          <div class="form-group">
            <label>{{ $t("commons.label_start_date") }}</label>
            <DatePickerFormFlex
              :propsDate="searchData.startDate"
              @emitDate="startDate"
              v-model="searchData.startDate"
              v-on:keyup.enter="search"
            />
          </div>
        </CCol>
        <CCol sm="2">
          <div class="form-group">
            <label>{{ $t("commons.label_end_date") }}</label>
            <DatePickerFormFlex
              :propsDate="searchData.endDate"
              @emitDate="endDate"
              v-model="searchData.endDate"
              v-on:keyup.enter="search"
            />
          </div>
        </CCol>
        <CCol sm="2">
          <div class="form-group">
            <label>{{ $t("employee.label_employee_division") }}</label>
            <select
              class="form-control"
              v-model="searchData.divisionCode"
              @change="search"
            >
              <option value="0">{{
                $t("placeholder.label_employee_option_search")
              }}</option>
              <option
                :value="item.code"
                v-for="(item, index) in divisions"
                :key="index"
                >{{ item.name }}</option
              >
            </select>
          </div>
        </CCol>
        <CCol sm="2">
          <div class="form-group">
            <label>{{ $t("commons.label_project_name") }}</label>
            <select
              class="form-control"
              v-model="searchData.projectId"
              @change="search"
            >
              <option value="0">{{ $t("employee.select_option") }}</option>
              <option
                v-for="(option, key, index) in commonProjects"
                :key="index"
                :value="key"
                >{{ option.project_name }}</option
              >
            </select>
          </div>
        </CCol>
      </CRow>
      <CRow>
        <CCol sm="2">
          <div class="form-group">
            <label>{{ $t("commons.label_approve_person") }}</label>
            <CInput
              v-model="searchData.approvePerson"
              :placeholder="
                this.$t('placeholder.label_approve_person_over_time_request')
              "
              v-on:keyup.enter="search"
            />
          </div>
        </CCol>
        <CCol sm="2">
          <div class="form-group">
            <label>{{ $t("commons.label_status") }}</label>
            <select
              class="form-control"
              v-model="searchData.status"
              @change="search"
            >
              <option value="0">
                {{ $t("employee.select_option") }}
              </option>
              <option value="1">{{
                $t("commons.label_status_overtime_request_1")
              }}</option>
              <option value="2">{{
                $t("commons.label_status_overtime_request_2")
              }}</option>
              <option value="3">{{
                $t("commons.label_status_overtime_request_3")
              }}</option>
            </select>
          </div>
        </CCol>
        <CCol sm="3" class="btn-search text-center">
          <CButton class="btn-search-employee" @click.prevent="search">
            {{ $t("button.label_employee_btn_search") }}
          </CButton>
          <CButton class="btn-reset" @click="resetForm">{{
            $t("button.label_action_reset")
          }}</CButton>
        </CCol>
      </CRow>
    </CCard>
     <CRow v-if="totalOverTimeRequests.total > 0">
      <CCol sm="12">
        <CCard class="employee-table1">
          <CCardBody class="car_body">
          <table class="table1">
                <th class="padding_table">Họ và tên </th>
                <th class="center">Người duyệt cấp 1</th>
                <th class="center">Người duyệt cấp 2</th>
              <tr v-for="(item, index) in totalOverTimeRequests" :key="index">
                <td v-if="index != 'total' && index != ''" class="padding_table">{{index}}</td>
                <td v-if="index != 'total' && index != 0" class="center">{{item.level1}}</td>
                <td v-if="index != 'total' && index != 0" class="center">{{item.level2}}</td>
              </tr>
              <tr>
                <th class="padding_table">Tổng</th>
                <td colspan="2" class="center">{{totalOverTimeRequests.total}}</td>
              </tr>
            </table>
            </CCardBody>
            </CCard>
       </CCol>
    </CRow>
    <CRow>
      <CCol sm="12">
        <CCard class="employee-table">
          <CCardBody>
            <div class="option-table">
              <div class="form-group">
                <select
                  class="form-control select-per-page"
                  v-model="searchData.itemsPerPage"
                  @change="search"
                >
                  <option
                    v-for="(item, index) in listItemsPerPage"
                    :value="item"
                    :key="index"
                    >{{ item }}</option
                  >
                </select>
              </div>
              <div class="test1">
              <div style="padding: 7px">
              <template
                v-if="overTimeRequests.data && overTimeRequests.data.length > 0"
              >
                <div class="show-text-table">
                  {{ $t("commons.label_text_show") }}
                  {{ searchData.paginate.from }}
                  {{ $t("commons.label_text_to") }}
                  {{ searchData.paginate.to }}
                  {{ $t("commons.label_text_of") }}
                  {{ searchData.paginate.totalRecord }}
                  {{ $t("commons.label_text_entries") }}
                </div>
              </template>
              <template v-else>
                <div class="show-text-table">
                  {{ $t("commons.label_text_show") }}
                  {{ searchData.paginate.from }}
                  {{ searchData.paginate.to }}
                  {{ searchData.paginate.totalRecord }}
                  {{ $t("commons.label_text_entries") }}
                </div>
              </template>
              </div>
              <div>
              <CCol class="btn-export">
                <CButton color="warning ml-3" @click="exportData">Export</CButton>
              </CCol>
              </div>
              </div>
            </div>
            <div class="table-responsive">
              <table class="table table-mobile table-tablet">
                <thead>
                  <tr>
                    <th>#</th>
                    <th>{{ $t("employee.label_employee_code") }}</th>
                    <th scope="col">
                      {{ $t("employee.label_employee_name") }}
                    </th>
                    <th scope="col">
                      {{ $t("employee.label_employee_position") }}
                    </th>
                    <th scope="col">
                      {{ $t("employee.label_employee_division") }}
                    </th>
                    <th scope="col">{{ $t("commons.label_project_name") }}</th>
                    <th scope="col">
                      {{ $t("employee.label_employee_over_time_date") }}
                    </th>
                    <th scope="col">
                      {{ $t("employee.label_employee_date_start") }}
                    </th>
                    <th scope="col">
                      {{ $t("employee.label_employee_date_end") }}
                    </th>
                    <th scope="col">
                      {{ $t("commons.label_total_number_hour") }}
                    </th>
                    <th>{{ $t("commons.label_status_approval") }}</th>
                    <th scope="col">{{ $t("commons.label_status") }}</th>
                    <th scope="col">
                      {{ $t("commons.label_employee_action") }}
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <template
                    v-if="
                      overTimeRequests.data && overTimeRequests.data.length > 0
                    "
                  >
                    <tr
                      v-for="(item, index) in overTimeRequests.data"
                      :key="index"
                    >
                      <th scope="row">
                        {{ getNumberRow(overTimeRequests, index) }}
                      </th>
                      <td>{{ item.employee_id }}</td>
                      <td>{{ item.employee ? item.employee.name : "" }}</td>
                      <td>
                        {{
                          item.employee
                            ? objectNotNull(item.employee.position)
                              ? item.employee.position.name
                              : ""
                            : ""
                        }}
                      </td>
                      <td>
                        {{
                          item.employee
                            ? objectNotNull(item.employee.department)
                              ? item.employee.department.name
                              : ""
                            : ""
                        }}
                      </td>
                      <td>{{ item.project ? item.project.name : "" }}</td>
                      <td>{{ item.date | formatDate }}</td>
                      <td>{{ item.start_time }}</td>
                      <td>{{ item.end_time }}</td>
                      <td>{{ item.duration }}</td>
                      <td>
                        <ul>
                          <li
                            v-for="(employeeApproval,
                            key) in over_time_request_approves"
                            :key="key"
                          >
                            <template
                              v-if="
                                parseInt(item.id) ===
                                  parseInt(
                                    employeeApproval.over_time_request_id
                                  )
                              "
                            >
                              {{ employeeApproval.employees[0].name }} :
                              {{
                                $t(
                                  `overtime.employee_approval_${employeeApproval.status}`
                                )
                              }}
                            </template>
                          </li>
                        </ul>
                      </td>
                      <td
                        v-bind:class="
                          item.status ? 'color-status-' + item.status : ''
                        "
                      >
                        <CBadge color="secondary">{{
                          $t(
                            `commons.label_status_overtime_request_${item.status}`
                          )
                        }}</CBadge>
                      </td>
                      <td>
                        <router-link
                          :to="{ path: `/overtime-requests/detail/${item.id}` }"
                        >
                          <CButton
                            color="primary"
                            variant="outline"
                            square
                            size="sm"
                          >
                            {{ $t("button.label_action_show") }}
                          </CButton>
                        </router-link>
                      </td>
                    </tr>
                  </template>
                  <template v-else>
                    <tr>
                      <td colspan="12" class="text-center">
                        {{ $t("table.label_data_not_found") }}
                      </td>
                    </tr>
                  </template>
                </tbody>
              </table>
            </div>
          </CCardBody>
          <CPagination
            v-if="overTimeRequests.data && overTimeRequests.data.length > 0"
            :activePage.sync="searchData.paginate.currentPage"
            :pages="searchData.paginate.totalPage"
            @update:activePage="changePage"
            size="sm"
            align="center"
          />
        </CCard>
      </CCol>
    </CRow>
  </div>
</template>

<script>
import XLSX from "xlsx";
import { mapActions, mapGetters } from "vuex";
import DatePickerFormFlex from "@/components/Common/DatePickerFormFlex";
import moment from "moment";

export default {
  name: "Overtime",
  metaInfo() {
    return {
      title: this.$t("page_title.page_overtime_request_list"),
      titleTemplate: "%s | " + this.$t("page_title.head_title")
    };
  },
  components: {
    DatePickerFormFlex
  },
  data() {
    return {
      over_time_request_approves: [],
      searchData: {
        info: "",
        divisionCode: 0,
        positionId: 0,
        startDate: "",
        endDate: "",
        projectId: 0,
        approvePerson: "",
        status: 0,
        itemsPerPage: 10,
        paginate: {
          from: 0,
          to: 0,
          totalPage: 0,
          path: "",
          currentPage: 1,
          totalRecord: 0,
          perPage: 0
        }
      },
      export: true
    };
  },
  computed: {
    ...mapGetters({
      overTimeRequests: "overtime-request/overTimeRequests",
      overTimeRequestsExport: "overtime-request/overTimeRequestsExport",
      divisions: "commons/divisions",
      positions: "commons/positions",
      commonProjects: "overtime-request/commonProjects",
      listItemsPerPage: "commons/listItemsPerPage",
      pagination: "overtime-request/pagination",
      totalOverTimeRequests: "overtime-request/totalOverTimeRequests"
    }),
  },
  methods: {
    ...mapActions("overtime-request", [
      "listOverTimeRequest",
      "listOverTimeRequestExport"
    ]),
    ...mapActions("layout", ["setLoading"]),

    startDate(data) {
      this.searchData.startDate = data;
    },

    endDate(data) {
      this.searchData.endDate = data;
    },

    getNumberRow(data, index) {
      return (data.current_page - 1) * data.per_page + index + 1;
    },

    resetForm() {
      this.searchData.info = "";
      this.searchData.divisionCode = 0;
      this.searchData.positionId = 0;
      this.searchData.startDate = this.getDateSearch().firstDay;
      this.searchData.endDate = this.getDateSearch().lastDay;
      this.searchData.projectId = 0;
      this.searchData.approvePerson = "";
      this.searchData.status = 0;
    },

    getDateSearch() {
      let date = new Date();
      let currentDay = moment(date).format("YYYY-MM-DD");
      let firstDay = "";
      if (
        moment(new Date(date.getFullYear(), date.getMonth(), 1)).format(
          "YYYY-MM-DD"
        ) <= currentDay &&
        currentDay <=
          moment(new Date(date.getFullYear(), date.getMonth(), 5)).format(
            "YYYY-MM-DD"
          )
      ) {
        firstDay = new Date(date.getFullYear(), date.getMonth() - 1, 1);
      }
      if (
        currentDay >
        moment(new Date(date.getFullYear(), date.getMonth(), 5)).format(
          "YYYY-MM-DD"
        )
      ) {
        firstDay = new Date(date.getFullYear(), date.getMonth(), 1);
      }
      return {
        firstDay: Intl.DateTimeFormat("en-GB").format(firstDay),
        lastDay: ""
      };
    },

    async getLists() {
      await this.listOverTimeRequest({
        optionPage: this.searchData.itemsPerPage,
        currentPage: this.searchData.paginate.currentPage,
        employeeInfo: this.searchData.info.toLowerCase(),
        divisionCode: this.searchData.divisionCode,
        positionId: parseInt(this.searchData.positionId),
        start_date: this.searchData.startDate,
        end_date: this.searchData.endDate,
        projectId: parseInt(this.searchData.projectId),
        approvePerson: this.searchData.approvePerson.toLowerCase(),
        status: parseInt(this.searchData.status)
      });
      this.searchData.paginate = this.pagination;
      this.over_time_request_approves = [];
      for (let index of this.overTimeRequests.data) {
        for (let key in index.over_time_request_approves) {
          this.over_time_request_approves.push(
            index.over_time_request_approves[key]
          );
        }
      }
    },

    async search() {
      this.setLoading(true);
      try {
        this.searchData.paginate.currentPage = 1;
        await this.getLists();
        this.setLoading(false);
      } catch {
        this.setLoading(false);
      }
    },

    async exportData() {
      this.setLoading(true);
      await this.listOverTimeRequestExport({
        employeeInfo: this.searchData.info.toLowerCase(),
        divisionCode: this.searchData.divisionCode,
        positionId: parseInt(this.searchData.positionId),
        start_date: this.searchData.startDate,
        end_date: this.searchData.endDate,
        projectId: parseInt(this.searchData.projectId),
        approvePerson: this.searchData.approvePerson.toLowerCase(),
        status: parseInt(this.searchData.status),
        export: this.export
      })
        .then(() => {
          this.setLoading(false);
          this.$toast(
            this.$t("popup.label_popup_export_success"),
            null,
            2000,
            "b-toaster-top-center",
            "success"
          );
        })
        .catch(() => {
          this.setLoading(false);
        });

      let Heading = [
        [
          "Mã nhân viên",
          "Họ và tên",
          "Vị trí­",
          "Bộ phận",
          "Dự án",
          "Ngày OT",
          "Thời gian bắt đầu",
          "Thời gian kết thúc",
          "Tổng số giờ",
          "Lí do",
          "Trạng thái"
        ]
      ];
      var ws = XLSX.utils.aoa_to_sheet(Heading);
      console.log(this.overTimeRequestsExport);
      ws = XLSX.utils.sheet_add_json(ws, this.overTimeRequestsExport, {
        skipHeader: true,
        origin: "A2"
      });
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, "SheetJS");
      XLSX.writeFile(wb, "DanhsachphieuOT.xlsx");
    },

    changePage(page) {
      this.getLists(this.searchData.itemsPerPage, page);
    },

    objectNotNull(obj) {
      if (obj) {
        return Object.keys(obj).length !== 0;
      }
    }
  },
  created() {
    this.searchData.startDate = this.getDateSearch().firstDay;
    this.searchData.endDate = this.getDateSearch().lastDay;
    this.getLists();
  }
};
</script>

<style lang="scss" scoped>
.test1{
  display: flex;
}
.padding_table{
  padding: 0 5px;
}
.car_body{
      padding: 10px 31px;
}
.center{
  text-align: center;
}
  .row_table{
    padding: 15px;
  }
.table1{
    background: #f8f8f8;
    width: 50%;
    th,
    td{
      padding: 5px;
      border:1px solid #d8dbe0;
    }
}
  .employee-table1 {
    margin: 0;
    border-radius: 0;
  }
.employee {
  margin: -2rem -30px 30px -30px;
  .card{
    margin-bottom: 1rem;
  }
  .card-table-emloyee {
    padding: 30px;
  }
  .btn-search-employee {
    background-color: #b5dbf2;
    padding: 8px;
    width: 120px;
  }
  .employee-table {
    margin: 0 20px 0 30px;
  }
  .select-per-page {
    width: 70px;
  }
  .option-table {
    display: flex;
    justify-content: space-between;
  }
  .btn-search {
    margin-top: 25px;
  }
  .btn-export {
    text-align: right;
    button {
      margin-bottom: 10px;
    }
  }
  td.color-status-3 {
    span.badge.badge-secondary {
      background: #dc1313;
      color: #ffffff;
    }
  }

  td.color-status-2 {
    span.badge.badge-secondary {
      background: #006400;
      color: #ffffff;
    }
  }

  table.table td {
    margin: auto;
    ul {
      list-style-type: none;
      padding-left: 0px;
      margin-bottom: 0px;
      li {
        text-align: left;
      }
    }
  }
  th,
  td {
    vertical-align: middle !important;
  }
}
@media only screen and (max-device-width: 480px) {
  .show-text-table {
    margin-top: 0.5rem;
  }
  .employee .employee-table {
    margin: 0;
  }
}
@media only screen and (max-device-width: 767px) {
  .employee .btn-export button {
    margin: -12px 30px 10px 0;
  }
  .employee .option-table {
    padding: 0 0.5rem;
  }
  .table-mobile {
    width: 1400px;
    overflow-x: scroll;
  }
}
@media only screen and (min-device-width: 768px) and (max-device-width: 1024px) {
  .table-tablet {
    width: 1400px;
    overflow-x: scroll;
  }
}
</style>
